<ng-container *transloco="let tr; prefix: 'profile'; scope: 'profile'">
  <nz-page-header class="site-page-header" nzBackIcon (nzBack)="onBackClicked()">
    <nz-page-header-title>{{tr('editPassword.title')}}</nz-page-header-title>
  </nz-page-header>
  <form nz-form *ngIf="form" [formGroup]="form" [nzLayout]="'horizontal'" (ngSubmit)="saveProfile()">
    <nz-form-item>
      <nz-form-control [nzOffset]="8">
        <nz-upload class="avatar-uploader" [nzAction]="fileUploadUrl" nzListType="picture-card"
                   [nzHeaders]="fileUploadHeadersFn"
                   [nzData]="avatarDataFn"
                   [nzShowUploadList]="false" (nzChange)="handleUploadChange($event, 'avatar')">
          <ng-container *ngIf="!avatarUrl">
            <i class="upload-icon" nz-icon [nzType]="isLoading.avatarFile ? 'loading' : 'plus'"></i>
            <div class="ant-upload-text">{{tr('form.avatarFileId')}}</div>
          </ng-container>
          <img *ngIf="avatarUrl" alt="avatar" [src]="avatarUrl" style="width: 100%" />
        </nz-upload>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngFor="let c of ['iin', 'firstname','lastname', 'patronymic', 'email']">
      <nz-form-label [nzXs]="8">{{tr('form.' + c)}}</nz-form-label>
      <nz-form-control>
        <input nz-input [formControlName]="c"/>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="8">{{tr('form.birthdate')}}</nz-form-label>
      <nz-form-control>
        <nz-date-picker formControlName="birthdate" [nzMode]="'date'"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="8">{{tr('form.gender')}}</nz-form-label>
      <nz-form-control>
        <nz-radio-group formControlName="gender" nzName="gender">
          <label nz-radio nzValue="MALE">{{tr('gender.male')}}</label>
          <label nz-radio nzValue="FEMALE">{{tr('gender.female')}}</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="8">{{tr('form.maritalStatus')}}</nz-form-label>
      <nz-form-control>
        <nz-select formControlName="maritalStatus" nzAllowClear>
          <nz-option [nzValue]="'MARRIED'" [nzLabel]="tr('maritalStatus.MARRIED')"></nz-option>
          <nz-option [nzValue]="'SINGLE'" [nzLabel]="tr('maritalStatus.SINGLE')"></nz-option>
          <nz-option [nzValue]="'DIVORCED'" [nzLabel]="tr('maritalStatus.DIVORCED')"></nz-option>
          <nz-option [nzValue]="'WIDOWED'" [nzLabel]="tr('maritalStatus.WIDOWED')"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control [nzOffset]="8">
        <nz-upload class="avatar-uploader" [nzAction]="fileUploadUrl" nzListType="picture-card"
                   [nzHeaders]="fileUploadHeadersFn"
                   [nzData]="signDataFn"
                   [nzShowUploadList]="false" (nzChange)="handleUploadChange($event, 'sign')">
          <ng-container *ngIf="!signUrl">
            <i class="upload-icon" nz-icon [nzType]="isLoading.signFile ? 'loading' : 'plus'"></i>
            <div class="ant-upload-text">{{tr('form.signFileId')}}</div>
          </ng-container>
          <img *ngIf="signUrl" alt="sign" [src]="signUrl" style="width: 100%" />
        </nz-upload>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control [nzOffset]="8">
        <button [nzLoading]="isLoading.save" nz-button nzType="primary">{{'button.save' | transloco}}</button>
      </nz-form-control>
    </nz-form-item>

  </form>
</ng-container>
